"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribableBoard = void 0;
const board_1 = require("./board");
class SubscribableBoard extends board_1.Board {
    constructor() {
        super(...arguments);
        this.listeners = new Set();
        this.version = 0;
        this.rafScheduled = false;
        this.pendingNotify = false;
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => this.listeners.delete(listener);
        };
        this.getSnapshot = () => this.version;
    }
    setPieces(pieces) {
        super.setPieces(pieces);
        // big change; paint now
        this.markChanged({ immediate: true });
    }
    setPiece(pieceId, x, y) {
        super.setPiece(pieceId, x, y);
        this.markChanged();
    }
    removePiece(pieceId) {
        super.removePiece(pieceId);
        this.markChanged();
    }
    swapPieces(pieceIdA, pieceIdB) {
        super.swapPieces(pieceIdA, pieceIdB);
        this.markChanged();
    }
    clear() {
        super.clear();
        // bulk change; paint now
        this.markChanged({ immediate: true });
    }
    markChanged(opts) {
        var _a;
        this.version++;
        const immediate = (_a = opts === null || opts === void 0 ? void 0 : opts.immediate) !== null && _a !== void 0 ? _a : false;
        // coalesce to the next animation frame to avoid excessive renders
        const shouldCoalesce = !immediate &&
            typeof window !== "undefined" &&
            typeof requestAnimationFrame !== "undefined";
        if (!shouldCoalesce) {
            this.notifyListeners();
            return;
        }
        this.pendingNotify = true;
        if (this.rafScheduled) {
            return;
        }
        this.rafScheduled = true;
        requestAnimationFrame(() => {
            this.rafScheduled = false;
            if (!this.pendingNotify) {
                return;
            }
            this.pendingNotify = false;
            this.notifyListeners();
        });
    }
    notifyListeners() {
        for (const l of this.listeners) {
            l();
        }
    }
}
exports.SubscribableBoard = SubscribableBoard;
